import { useFeatureToggles } from 'shared/legacy/hooks/useFeatureToggles';
import { useContextSelector } from 'use-context-selector';
import { EnrichVacancyModalContext } from '../components/EnrichVacancyModalContext/EnrichVacancyModalContext';

export const useEnrichedVacancyModalSettings = () => {
  const { isFeatureToggleEnabled } = useFeatureToggles();
  const vacancy = useContextSelector(EnrichVacancyModalContext, (s) => s.vacancy);

  const isJobPreviewFeatureEnabled = isFeatureToggleEnabled((f) => f.RJ_COMMUNICATION_HUB);

  const isJobPreviewTabVisible = (() => {
    if (vacancy?.type === 'INDEED') {
      return !vacancy.originalIndeedJob;
    }

    return true;
  })();

  const isJobDescriptionTabVisible = (() => {
    if (vacancy?.type === 'INDEED') {
      return !!vacancy.originalIndeedJob;
    }

    if (vacancy?.type === 'CREATED') {
      return false;
    }

    return true;
  })();

  return {
    isJobPreviewFeatureEnabled,
    isJobPreviewTabVisible,
    isJobDescriptionTabVisible,
  };
};
